import { Injectable, signal } from '@angular/core';
import { BreakdownTechnician, CallcentreOperator, ClientLink, ClientMeta, ClientMetaFlags, Driver, LookupItem, SavedLocation, ServiceProviderLink, TyreBrand, TyreSize, Vehicle } from '../models/client';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { NotificationService } from './notification.service';
import { AuthService } from '../auth.service';
import { SocketMessage } from '../models/websocket';
import { WhatsappMessage } from '../models/whatsapp';
import { PriceTemplate } from '../models/pricing';
import { Incident } from '../models/incident';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  //METADATA
  public tyreBrands: TyreBrand[] = [];
  public tyreSizes: TyreSize[] = [];
  public truckDrivers: Driver[] = [];
  public fleetVehicles: Vehicle[] = [];
  public clientLinks: ClientLink[] = [];
  public serviceProviderLinks: ServiceProviderLink[] = [];
  public breakdownTechnicians: BreakdownTechnician[] = [];
  public savedLocations: SavedLocation[] = [];
  public priceTemplates: PriceTemplate[] = [];
  public workDoneTypes: LookupItem[] = [];
  public cancelReasons: LookupItem[] = [];
  public callcentreOperators: CallcentreOperator[] = [];
  public isLoadingMetaData = new BehaviorSubject<boolean>(false);
  public metadataLoaded = new Subject<void>();
  public callcentreOperatorSelectionRequested = new Subject<void>();
  //OTHER SERVICE DATA
  public messages: SocketMessage[] = [];
  public isWhatsappDrawerVisible: boolean = false;
  //public selectedMessage: WhatsappMessage | null = null;
  public selectedMessages: WhatsappMessage[] = [];
  public newIncident: Incident | null = null;
  public isOnDataCaptureMode = false;
  
  //public selectedMessageIds: number[] = [];
  //public selectedNewIncidentJSON: string | null = null;
  public flags = signal<ClientMetaFlags>(new ClientMetaFlags());

  
  constructor(private http: HttpClient, private notification: NotificationService, private authService : AuthService) { }

 
  public loadMetaData(): void {
    this.isLoadingMetaData.next(true);
    this.http.get<ClientMeta>(environment.apiUrl + "v1/client/metadata").subscribe({
      next: (data) => {
        this.tyreBrands = data.tyreBrands;
        this.tyreSizes = data.tyreSizes;
        this.truckDrivers = data.truckDrivers;
        this.fleetVehicles = data.fleetVehicles;
        this.clientLinks = data.clientLinks;
        this.serviceProviderLinks = data.serviceProviderLinks;
        this.breakdownTechnicians = data.breakdownTechnicians;
        this.savedLocations = data.savedLocations;
        this.priceTemplates = data.priceTemplates;
        this.workDoneTypes = data.workDoneTypes;
        this.cancelReasons = data.cancelReasons;
        this.callcentreOperators = data.callcentreOperators ?? [];
        this.flags.set(data.flags);
        this.metadataLoaded.next();
        this.isLoadingMetaData.next(false);
      },
      error: (error) => {
        this.isLoadingMetaData.next(false);
        this.notification.handleError(error, "Error loading background client data. Please check your internet connection and log in again.");
      }
    });
  }

  public requestCallcentreOperatorSelection(): void {
    this.callcentreOperatorSelectionRequested.next();
  }

  public loadTyreSizes(): void {
    this.http.get<TyreSize[]>(environment.apiUrl + "v1/client/metadata/tyresizes").subscribe({
      next: (data) => {
        this.tyreSizes = data;
      }
    });
  }

  public get premiumTyreBrands(): TyreBrand[] {
    return this.tyreBrands.filter(brand => brand.isImport === false && brand.isRetread === false);
  }

  public get hasFleets() : boolean {
    return this.clientLinks.some(link => link.connectionTypeId === 1);
  }

  public addFleetClientLink(fleetClient: ClientLink) {
    //first check if it already exists
    let existing = this.clientLinks.find(link => link.clientId === fleetClient.clientId && link.connectionTypeId === 1);
    if (!existing) {
      this.clientLinks.push(fleetClient);
    }
  }

  public get hasCallcentres(): boolean {
    return this.clientLinks.some(link => link.connectionTypeId === 2);
  }

  public get hasTechnicians(): boolean {
    return this.clientLinks.some(link => link.connectionTypeId === 3);
  }

  public get getFleets(): ClientLink[] {
    return this.clientLinks.filter(link => link.connectionTypeId === 1);
  }

  public get getCallcentres(): ClientLink[] {
    return this.clientLinks.filter(link => link.connectionTypeId === 2);
  }
  
  public get getServiceProviders(): ClientLink[] {
    return this.clientLinks.filter(link => link.connectionTypeId === 3);
  }

  // public selectedMessageAsObject(): WhatsappMessage {
  //   return JSON.parse(this.selectedMessage!) as WhatsappMessage;
  // }

  public messageAsObject(msg: SocketMessage): WhatsappMessage {
    return JSON.parse(msg.message) as WhatsappMessage;
  }

  public uploadFile(file: {name: string, base64: string}): number {
    //logic will be added later
    return 1;
  }
}
